"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../constants");

var utils_1 = require("../../utils");

var Section_1 = __importDefault(require("./Section"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
* Story SideBar component.
*/


var SideBar = function SideBar(_a) {
  var activeIndex = _a.activeIndex,
      children = _a.children,
      description = _a.description,
      image = _a.image,
      logo = _a.logo,
      onSelect = _a.onSelect,
      title = _a.title,
      type = _a.type;
  var classes = (0, useStyles_1.default)();
  /* eslint-disable react/jsx-props-no-spreading */

  var sections = react_1.default.Children.map(children, function (_a) {
    var childProps = _a.props;
    var color = childProps.color,
        icon = childProps.icon,
        index = childProps.index,
        label = childProps.label;
    var sectionProps = {
      icon: icon,
      index: index,
      isActive: activeIndex === index,
      onClick: onSelect,
      text: label
    };

    if (color) {
      sectionProps.accentColor = color.background;
      sectionProps.textColor = color.text;
    }

    return react_1.default.createElement(Section_1.default, __assign({}, sectionProps, {
      key: index
    }));
  });
  var containerClasses = (0, utils_1.classList)(classes.sideBar, 'story-sidebar', "story-sidebar-" + type);
  return react_1.default.createElement("div", {
    className: containerClasses
  }, logo && react_1.default.createElement("div", {
    className: classes.logoContainer
  }, logo), (title || description) && react_1.default.createElement("div", {
    className: classes.title
  }, react_1.default.createElement(Typography_1.default, {
    color: "primary",
    variant: "overline"
  }, title, react_1.default.createElement(Divider_1.default, null)), react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "caption"
  }, description)), image && react_1.default.createElement(CardMedia_1.default, {
    className: classes.image,
    component: "img",
    image: image,
    title: title
  }), sections, react_1.default.createElement("div", {
    className: classes.footer
  }, react_1.default.createElement(Button_1.default, {
    className: classes.link,
    color: "secondary",
    href: constants_1.STORIES_API_HOMEPAGE,
    target: "_blank"
  }, "POWERED BY THE STORIES SERVICES")));
};

SideBar.propTypes = {
  activeIndex: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),

  /** List of `Moment`s to render information from */
  children: prop_types_1.default.arrayOf(prop_types_1.default.element).isRequired,
  description: prop_types_1.default.string,
  image: prop_types_1.default.string,
  logo: prop_types_1.default.element,
  onSelect: prop_types_1.default.func,
  title: prop_types_1.default.string,
  type: prop_types_1.default.string
};
SideBar.defaultProps = {
  activeIndex: undefined,
  description: undefined,
  image: undefined,
  logo: undefined,
  onSelect: function onSelect() {},
  title: '',
  type: 'base'
};
exports.default = SideBar;